import React from 'react';
import PropTypes from 'prop-types';
import Link from 'components/AppSafeLink/AppSafeLink';

const TranscriptText = ({ transcriptText }) => {
  const regex = new RegExp(/\n/, 'g');
  const __html = transcriptText.replace(regex, '<br />');
  return (
    <div className="transcript_text" dangerouslySetInnerHTML={{ __html }} />
  );
};

TranscriptText.propTypes = {
  transcriptText: PropTypes.string,
};

const Transcript = (props) => {
  const TranscriptPdfUrl = props.transcripts?.filter(
    (file) => file.formatSlug == 'pdf'
  )[0]?.url;

  if (!props.transcriptText && !TranscriptPdfUrl) {
    return null;
  }

  if (props.transcriptText) {
    return (
      <div className="transcript">
        <h3>Audio transcript</h3>
        {props.transcriptText && (
          <TranscriptText transcriptText={props.transcriptText} />
        )}
        {TranscriptPdfUrl && (
          <h3 className="transcript_pdf">
            <Link href={TranscriptPdfUrl}>Download transcript (PDF)</Link>
          </h3>
        )}
        <p className="transcript_credit">
          Transcription services provided by{' '}
          <Link href="https://www.3playmedia.com/">3Play Media</Link>.
        </p>
      </div>
    );
  } else {
    return null;
  }
};

Transcript.propTypes = {
  transcripts: PropTypes.arrayOf(
    PropTypes.shape({
      mediaType: PropTypes.string,
      formatSlug: PropTypes.string,
      url: PropTypes.string,
    })
  ),
  transcriptText: PropTypes.string,
};

export default Transcript;
